export default __webpack_public_path__ + "static/media/Neon_Violet_Square_LE.d25a583b.jpg";